import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => classNames(
    className,
  ),
};

export default styles;
